import React from 'react';
import * as S from './References.styles';
import { LinkedinOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      {/* <S.Text>Made by Arjun Gupta</S.Text> */}
      <S.Icons>
        <a href="https://www.linkedin.com/in/arjun-d-gupta/" target="_blank" rel="noreferrer">
          <LinkedinOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
